import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CalendarEventForm from '../containers/CalendarEventFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CalendarEventAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CalendarEventAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('calendar_event_route_add')} />
          <CalendarEventForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CalendarEventAddScreen;

Logger.log('silly', `CalendarEventAddScreen loaded.`);
